// src/hooks/useImageLoading.js
import { useState, useEffect } from 'react';

export const useImageLoading = (images) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!images || images.length === 0) {
            setLoading(false);
            return;
        }

        const loadImage = (src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                img.onload = resolve;
                img.onerror = reject;
            });
        };

        setLoading(true);
        Promise.all(images.map(src => loadImage(src)))
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }, [images]);

    return loading;
};